import './Loader.css';

const Loader = ({height, isLoaded}) => {
    
    return (
        <div className='wrap' style={{
            position: 'relative', 
            width: '100%', 
            height: `${height-100}px`,
            display: isLoaded ? 'none' : 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        }}>
            <div className='loader' style={{display: 'block'}}></div> 
        </div>
    )

};

export default Loader;